import { PreviewCandidatesModal } from "@/pages/reporting/recruiting/widgets/PreviewCandidatesModal.tsx";
import analyticsService, {
  analyticEvents,
  analyticProperties,
} from "@/services/analytics-service.ts";
import { AnalyticReportTypes } from "@/types/analytics/analytics.types.ts";
import { useModals } from "@skailer-com/uikit";
import { useCallback } from "react";

export const useRecruitingReports = (reportType: AnalyticReportTypes | undefined = undefined) => {
  const modalsService = useModals();

  const handlePreviewApplicants = useCallback(
    (applicantIds: number[], reportType: AnalyticReportTypes) => {
      analyticsService.trackEvent(analyticEvents.reporting.dataViewed, {
        [analyticProperties.title]: reportType,
      });

      modalsService.openModal(PreviewCandidatesModal, {
        applicantIds: applicantIds,
      });
    },
    [reportType]
  );

  return {
    handlePreviewApplicants,
  };
};
